import { ursaColors } from "@smartsheet/design-tokens";
import * as React from "react";
import { SVGProps } from "react";
import type { Range } from "./ProgressBarIcon";

interface StatusBarIconProps extends SVGProps<SVGSVGElement> {
    size: {
        height: number;
        width: number;
    };
    value: Range<0, 101>;
    emptyFillColor?: string;
    fillColor?: string;
}

const SvgComponent = ({
    fillColor = ursaColors.azure400,
    emptyFillColor = ursaColors.neutral00,
    size,
    value,
    ...props
}: StatusBarIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox={`0 0 ${size.width} ${size.height}`}
        {...props}
    >
        <rect
            x="3.69995"
            y="6"
            width={size.width * 0.89}
            height={size.height * 0.4}
            fill={emptyFillColor}
            stroke={fillColor}
            strokeWidth="1.4"
            strokeLinejoin="round"
        />
        <rect
            x="3"
            y="6"
            width={(size.width - 8) * (value / 100)}
            height={size.height * 0.4}
            fill={fillColor}
            stroke={fillColor}
            strokeWidth="1.4"
            strokeLinejoin="round"
        />
    </svg>
);

export default SvgComponent;
